// extracted by mini-css-extract-plugin
export default {"background":"PWReset_background__ZNtFp"};